import { Space, Table, Tabs, Tag, Typography } from "antd";
import classes from "./AppDashboard.module.scss";
import { DownloadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const dataSource = [
    {
        key: "1",
        name: "Service Portal",
        updated_date: "2021-09-01",
        details: "A portal for accessing various services.",
        tags: ["useful", "developer"],
    },
    {
        key: "2",
        name: "Service Registry",
        updated_date: "2021-09-01",
        details: "A registry for managing service endpoints.",
        tags: ["critical"],
    },
    {
        key: "3",
        name: "Service Monitoring",
        updated_date: "2021-09-01",
        details: "A tool for monitoring service health and performance.",
        tags: [ "monitoring"],
    },
    {
        key: "4",
        name: "Money In-Transaction",
        updated_date: "2021-09-01",
        details: "Handles incoming financial transactions.",
        tags: ["finance", "transactions"],
    },
    {
        key: "5",
        name: "Money Out-Transaction",
        updated_date: "2021-09-01",
        details: "Handles outgoing financial transactions.",
        tags: ["finance", "transactions"],
    },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Updated Date",
    dataIndex: "updated_date",
    key: "updated_date",
  },
  {
    title: "Details",
    dataIndex: "details",
    key: "details",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    render: (_, { tags }) => (
      <>
        {tags.map((tag) => {
          let color = tag.length > 5 ? "geekblue" : "green";
          if (tag === "finance") {
            color = "volcano";
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <a>
          <DownloadOutlined style={{ marginRight: "5px" }} />
          Load Schema
        </a>
      </Space>
    ),
  },
];

const TabContent = ({ schemaName, rows, columns }) => {
  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
        {schemaName}
      </Title>
      <div className={classes.tableContainer}>
        <Table dataSource={rows} columns={columns} />
      </div>
    </>
  );
};

const AppDashboard = () => {
  return (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
          Integrated App Dashboard
        </Title>
      </div>
      <div className={classes.tabContainer}>
        <Tabs
          style={{ height: "100%" }}
          tabPosition={"left"}
          items={new Array(3).fill(null).map((_, i) => {
            const id = (Math.random() + 1).toString(36).substring(7);
            const schemaName = `Schema ${id}`;
            return {
              label: schemaName,
              key: id,
              children: (
                <TabContent
                  schemaName={schemaName}
                  rows={dataSource}
                  columns={columns}
                />
              ), // TabContent is a component
            };
          })}
        />
      </div>
    </>
  );
};
export default AppDashboard;
